import { motion } from "framer-motion";
import {
  Code2,
  Database,
  Cloud,
  Cpu,
  Megaphone,
  TrendingUp,
  Palette,
  PenTool,
  Lightbulb,
  ArrowUpRight,
} from "lucide-react";
import { services } from "@/data/company";

const iconMap = { Code2, Database, Cloud, Cpu, Megaphone, TrendingUp, Palette, PenTool, Lightbulb };

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-12"
    >
      <div className="max-w-2xl mb-16">
        <p className="text-xs uppercase tracking-[0.2em] text-[#22d3ee] font-bold mb-4">
          What we do
        </p>
        <h2 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-white">
          Everything you need to build &amp; grow.
        </h2>
        <p className="mt-5 text-slate-400 text-base leading-relaxed">
          From the first line of code to your next viral campaign — one team,
          full ownership, real results.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {services.map((s, i) => {
          const Icon = iconMap[s.icon] || Code2;
          return (
            <motion.div
              key={s.key}
              data-testid={`service-card-${s.key}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.1 }}
              className="group relative bg-[#0a0f1e] p-8 md:p-10 hover:bg-[#10182b] transition-colors"
            >
              <div className="flex items-center justify-between mb-8">
                <div className="w-12 h-12 flex items-center justify-center bg-[#22d3ee]/10 border border-[#22d3ee]/20 text-[#22d3ee] rounded-sm group-hover:bg-[#22d3ee] group-hover:text-[#0a0f1e] transition-colors">
                  <Icon size={22} />
                </div>
                <ArrowUpRight
                  size={20}
                  className="text-slate-600 group-hover:text-[#22d3ee] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all"
                />
              </div>
              <h3 className="font-heading text-xl font-bold text-white mb-3">
                {s.title}
              </h3>
              <p className="text-sm text-slate-400 leading-relaxed">{s.desc}</p>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};
